document.addEventListener('DOMContentLoaded', () => {
  
  const heroSliderElement = document.querySelector('.hero-swiper');
  if (heroSliderElement && heroSliderElement.querySelector('.swiper-wrapper')) {
    try {
      const heroSwiper = new Swiper('.hero-swiper', {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        effect: 'creative',
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ['-120%', 0, -500],
          },
          next: {
            shadow: true,
            translate: ['120%', 0, -500],
          },
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
        }
      });
    } catch (error) {
      console.error('Error initializing hero slider:', error);
    }
  }

  const testimonialsSlider = document.querySelector('[data-slider="testimonials"]');
  if (testimonialsSlider && testimonialsSlider.querySelector('.swiper-wrapper')) {
    try {
      const nextBtn = testimonialsSlider.querySelector('[data-slider-next]');
      const prevBtn = testimonialsSlider.querySelector('[data-slider-prev]');
      const dots = testimonialsSlider.querySelector('.testimonials__dots');
      
      const testimonialsConfig = {
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        effect: 'slide',
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          }
        }
      };
      
      if (nextBtn && prevBtn) {
        testimonialsConfig.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn,
        };
      }
      
      if (dots) {
        testimonialsConfig.pagination = {
          el: dots,
          clickable: true,
          bulletClass: 'testimonials__dot',
          bulletActiveClass: 'testimonials__dot--active',
        };
      }
      
      const testimonialsSwiper = new Swiper(testimonialsSlider, testimonialsConfig);
    } catch (error) {
      console.error('Error initializing testimonials slider:', error);
    }
  }

  const latestProductsSlider = document.querySelector('[data-slider="latest-products"]');
  if (latestProductsSlider && typeof Swiper !== 'undefined') {
    const sectionElement = latestProductsSlider.closest('section');
    const nextEl = sectionElement ? sectionElement.querySelector('.products-slider__arrow--next') : null;
    const prevEl = sectionElement ? sectionElement.querySelector('.products-slider__arrow--prev') : null;
    const scrollbarEl = latestProductsSlider.querySelector('.swiper-scrollbar');
    
    const swiperConfig = {
      slidesPerView: 4.5,
      spaceBetween: 8,
      freeMode: false,
      loop: true,
      centeredSlides: false,
      breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 6,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 7,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 8,
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 8,
      }
      }
    };

    if (nextEl && prevEl) {
      swiperConfig.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    if (scrollbarEl) {
      swiperConfig.scrollbar = {
        el: scrollbarEl,
        hide: false,
      };
    }
    
    const latestProductsSwiper = new Swiper(latestProductsSlider, swiperConfig);
  }


});